import { useCookies } from 'vue3-cookies';
import { useCrypto } from './useCrypto';

export function useDonateInfoCookie() {
  const { cookies } = useCookies();
  const { encryptData, decryptData } = useCrypto();

  const setDonateInfoCookie = (data) => {
    const encryptedData = encryptData(JSON.stringify(data));
    // Must not outlive the 'isDonate' cookie set in useDonor.js. When
    // donate_info survived on its own (vue3-cookies defaults to 1 day) a
    // return to /donate re-ran the insert and created a second donation row.
    cookies.set('donate_info', encryptedData, '30min');
  };

  const getDonateInfoCookie = () => {
    const encryptedData = cookies.get('donate_info');
    if (encryptedData) {
      return JSON.parse(decryptData(encryptedData));
    }
    return null;
  };

  return {
    setDonateInfoCookie,
    getDonateInfoCookie,
  };
}
